import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';
import { IChingMethodStep } from '../../core/iching.models';
import { injectIChingTranslate } from '../iching-consult-translate';

/**
 * Korte uitleg boven een fase: de `lead` als één zin, met "Meer uitleg" dat
 * de langere alinea's (`more`) uitklapt. Herbruikbaar voor elke stap.
 */
@Component({
  selector: 'hd-iching-step-help',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    :host { display: block; font-size: 13.5px; line-height: 1.5; }
    .lead { margin: 0; }
    .toggle {
      margin-top: 4px; padding: 0; border: 0; background: none; font: inherit; font-size: 12.5px;
      color: var(--hd-iching-link, var(--primary, #3c4650)); text-decoration: underline; cursor: pointer;
    }
    .more { margin-top: 6px; padding-left: 12px; border-left: 2px solid var(--hd-iching-accent, rgba(212, 168, 105, 0.6)); }
    .more p { margin: 0 0 8px; }
  `,
  template: `
    <p class="lead">{{ step().lead }}</p>
    @if (step().more.length > 0) {
      <button type="button" class="toggle" data-test-id="iching-step-more" [attr.aria-expanded]="open()" (click)="open.set(!open())">
        {{ open() ? t('humanDesign.iching.consult.lessHelp') : t('humanDesign.iching.consult.moreHelp') }}
      </button>
      @if (open()) {
        <div class="more">
          @for (paragraph of step().more; track $index) {
            <p>{{ paragraph }}</p>
          }
        </div>
      }
    }
  `,
})
export class HdIChingStepHelpComponent {
  readonly step = input.required<IChingMethodStep>();

  protected readonly t = injectIChingTranslate();
  protected readonly open = signal(false);
}
